export const SET_LEAD_MANAGER_FILTERS = 'SET_LEAD_MANAGER_FILTERS';
export const SET_LEAD_MANAGER_ORDERING = 'SET_LEAD_MANAGER_ORDERING';
export const SET_LEAD_MANAGER_SEARCHBAR = 'SET_LEAD_MANAGER_SEARCHBAR';
